import React from 'react'

const contextObj = React.createContext({
  userDetails: null,
})

export default contextObj
